import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [NgxEchartsModule],
  template: `
    <div class="flex w-full h-full">
      <div echarts 
           [options]="barChartOptions" 
           [style.width]="'100%'"
           [style.height]="height + 'px'"
           >
      </div>
    </div>
  `,
  styles: ``
})
export class BarChartComponent implements OnChanges {
  @Input() data$: Observable<any[]> = of([]);
  @Input() height: number = 200;
  @Input() chartlabel: boolean = true;
  @Input() xAxisLabel: boolean = true;
  @Input() yAxisLabel: boolean = true;

  barChartOptions: EChartsOption = {};

  ngOnChanges(changes: SimpleChanges) {
    this.updateChartOptions();
  }

  updateChartOptions() {
    this.barChartOptions = {
      xAxis: {
        type: 'category',
        data: ['Dept. A', 'Dept. B', 'Dept. C', 'Dept. D'],
        axisLabel: { rotate: 0, show: this.xAxisLabel },
      },
      yAxis: {
        type: 'value',
        axisLabel: { formatter: '{value}%',show: this.yAxisLabel },
      },
      series: [
        {
          name: 'Category 1',
          type: 'bar',
          data: [55, 70, 40, 60],
          barWidth: '25%',
          itemStyle: { color: '#2C4F94' }
        },
        {
          name: 'Category 2',
          type: 'bar',
          data: [35, 60, 42, 38],
          barWidth: '25%',
          itemStyle: { color: '#E74C5E' }
        }
      ],
      tooltip: { trigger: 'axis' },
      legend: { show: this.chartlabel },
      grid: {
        left: '3%',
        right: '3%',
        top: '10%',
        bottom: '10%',
        containLabel: true
      },
    };
  }
}